export default __webpack_public_path__ + "static/media/BN.8e2fdccc.ico";